/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
import { useShallow } from 'zustand/react/shallow';
import { useGameStore } from '../stores/gameStore';

export function useGameCoreState() {
  return useGameStore(
    useShallow((s) => ({
      showLanding: s.showLanding,
      setShowLanding: s.setShowLanding,
      currentPage: s.currentPage,
      setCurrentPage: s.setCurrentPage,
      gameStarted: s.gameStarted,
      setGameStarted: s.setGameStarted,
      gameStatus: s.gameStatus,
      setGameStatus: s.setGameStatus,
      aiEnabled: s.aiEnabled,
      setAiEnabled: s.setAiEnabled,
      grid: s.grid,
      setGrid: s.setGrid,
      gameSpeed: s.gameSpeed,
      setGameSpeed: s.setGameSpeed,
      stats: s.stats,
      setStats: s.setStats,
      research: s.research,
      setResearch: s.setResearch,
      deltas: s.deltas,
      simBreakdown: s.simBreakdown,
      milestones: s.milestones,
      setMilestones: s.setMilestones,
      tickNumber: s.tickNumber,
    }))
  );
}